import { render, staticRenderFns } from "./order-table.component.vue?vue&type=template&id=8832cd62&"
import script from "./order-table.component.vue?vue&type=script&lang=js&"
export * from "./order-table.component.vue?vue&type=script&lang=js&"
import style0 from "./order-table.component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ksaffer/Projects/Client/natorp-plant-database/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8832cd62')) {
      api.createRecord('8832cd62', component.options)
    } else {
      api.reload('8832cd62', component.options)
    }
    module.hot.accept("./order-table.component.vue?vue&type=template&id=8832cd62&", function () {
      api.rerender('8832cd62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "_src/js/components/order-table.component.vue"
export default component.exports